var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "content-panel settings-page"
  }, [_vm.isAdmin ? _c('div', {
    staticClass: "settings-shell"
  }, [_vm._m(0), _c('div', {
    staticClass: "settings-layout"
  }, [_c('nav', {
    staticClass: "settings-navigation",
    attrs: {
      "aria-label": "Sekcie nastavení"
    }
  }, [_c('button', {
    staticClass: "settings-navigation-item",
    "class": {
      active: _vm.activeSection === 'rates'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.selectSection('rates');
      }
    }
  }, [_c('span', {
    staticClass: "navigation-icon"
  }, [_vm._v("%")]), _vm._m(1)]), _c('button', {
    staticClass: "settings-navigation-item",
    "class": {
      active: _vm.activeSection === 'financiers'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.selectSection('financiers');
      }
    }
  }, [_c('span', {
    staticClass: "navigation-icon"
  }, [_vm._v("👤")]), _vm._m(2)]), _vm._m(3), _c('button', {
    staticClass: "settings-navigation-item",
    "class": {
      active: _vm.activeSection === 'feedback'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.selectSection('feedback');
      }
    }
  }, [_c('span', {
    staticClass: "navigation-icon"
  }, [_vm._v("!")]), _vm._m(4)])]), _vm.activeSection === 'rates' ? _c('main', {
    staticClass: "settings-card"
  }, [_c('div', {
    staticClass: "card-heading"
  }, [_vm._m(5), _c('div', {
    staticClass: "heading-actions"
  }, [_c('button', {
    staticClass: "secondary-button",
    attrs: {
      "type": "button",
      "disabled": _vm.loading || _vm.savingAll || _vm.dirtyRateIds.length > 0
    },
    on: {
      "click": _vm.loadRates
    }
  }, [_vm._v(" Obnoviť ")]), _c('button', {
    staticClass: "primary-button",
    attrs: {
      "type": "button",
      "disabled": !_vm.dirtyRateIds.length || _vm.hasInvalidDirtyRates || _vm.savingAll
    },
    on: {
      "click": _vm.saveAll
    }
  }, [_vm._v(" " + _vm._s(_vm.savingAll ? "Ukladám..." : "Uložiť zmeny (" + _vm.dirtyRateIds.length + ")") + " ")])])]), _vm._m(6), _vm._m(7), _c('div', {
    staticClass: "filters"
  }, [_c('label', {
    staticClass: "filter-field search-field"
  }, [_c('span', [_vm._v("Hľadať")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.search,
      expression: "search",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "search",
      "placeholder": "Banka, účel alebo fixácia"
    },
    domProps: {
      "value": _vm.search
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.search = $event.target.value.trim();
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('label', {
    staticClass: "filter-field"
  }, [_c('span', [_vm._v("Banka")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.selectedBank,
      expression: "selectedBank"
    }],
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.selectedBank = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Všetky banky")]), _vm._l(_vm.bankOptions, function (bank) {
    return _c('option', {
      key: bank.code,
      domProps: {
        "value": bank.code
      }
    }, [_vm._v(" " + _vm._s(bank.name) + " ")]);
  })], 2)]), _c('label', {
    staticClass: "filter-field"
  }, [_c('span', [_vm._v("Účel")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.selectedPurpose,
      expression: "selectedPurpose"
    }],
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.selectedPurpose = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Všetky účely")]), _vm._l(_vm.purposeOptions, function (purpose) {
    return _c('option', {
      key: purpose.value,
      domProps: {
        "value": purpose.value
      }
    }, [_vm._v(" " + _vm._s(purpose.label) + " ")]);
  })], 2)])]), _vm.loading ? _c('div', {
    staticClass: "page-state"
  }, [_c('v-progress-circular', {
    staticClass: "loading-spinner small",
    attrs: {
      "indeterminate": ""
    }
  }), _c('span', [_vm._v("Načítavam sadzby...")])], 1) : _vm.loadError ? _c('div', {
    staticClass: "page-state error-state"
  }, [_c('strong', [_vm._v("Sadzby sa nepodarilo načítať.")]), _c('span', [_vm._v("Skontrolujte pripojenie alebo nasadenie API a skúste to znova.")]), _c('button', {
    staticClass: "secondary-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.loadRates
    }
  }, [_vm._v(" Skúsiť znova ")])]) : [_vm.lastUpdatedLabel ? _c('div', {
    staticClass: "last-updated"
  }, [_vm._v(" Posledná zmena v API: " + _vm._s(_vm.lastUpdatedLabel) + " ")]) : _vm._e(), _vm._l(_vm.groupedRates, function (group) {
    return _c('section', {
      key: group.code,
      staticClass: "bank-group"
    }, [_c('div', {
      staticClass: "bank-heading"
    }, [_c('div', {
      staticClass: "bank-monogram"
    }, [_vm._v(_vm._s(_vm.bankMonogram(group.name)))]), _c('div', [_c('h3', [_vm._v(_vm._s(group.name))]), _c('span', [_vm._v(_vm._s(group.rates.length) + " " + _vm._s(_vm.rateCountLabel(group.rates.length)))])])]), _vm._m(8, true), _vm._l(group.rates, function (rate) {
      return _c('div', {
        key: rate.id,
        staticClass: "rate-row",
        "class": {
          dirty: _vm.isRateDirty(rate),
          invalid: Boolean(_vm.rateValidationError(rate)),
          'hidden-rate': !rate.visible_on_website
        }
      }, [_c('div', {
        staticClass: "rate-purpose",
        attrs: {
          "data-label": "Účel"
        }
      }, [_c('strong', [_vm._v(_vm._s(rate.purpose_label))]), _vm.isRateDirty(rate) ? _c('small', [_vm._v("Neuložená zmena")]) : _vm._e()]), _c('div', {
        staticClass: "fixation-cell",
        attrs: {
          "data-label": "Fixácia"
        }
      }, [_vm._v(" FIX " + _vm._s(rate.fixation_years) + " ")]), _c('label', {
        staticClass: "rate-input",
        attrs: {
          "data-label": "Základná sadzba"
        }
      }, [_c('span', {
        staticClass: "sr-only"
      }, [_vm._v("Základná sadzba")]), _c('span', {
        staticClass: "number-input"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: rate.base_rate,
          expression: "rate.base_rate"
        }],
        attrs: {
          "type": "number",
          "min": "0",
          "max": "99.99",
          "step": "0.01",
          "inputmode": "decimal"
        },
        domProps: {
          "value": rate.base_rate
        },
        on: {
          "input": function input($event) {
            if ($event.target.composing) return;
            _vm.$set(rate, "base_rate", $event.target.value);
          }
        }
      }), _c('span', [_vm._v("%")])])]), _c('label', {
        staticClass: "rate-input",
        attrs: {
          "data-label": "Sadzba pre web"
        }
      }, [_c('span', {
        staticClass: "sr-only"
      }, [_vm._v("Sadzba pre web")]), _c('span', {
        staticClass: "number-input"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: rate.website_rate,
          expression: "rate.website_rate"
        }],
        attrs: {
          "type": "number",
          "min": "0",
          "max": "99.99",
          "step": "0.01",
          "inputmode": "decimal",
          "placeholder": "dediť"
        },
        domProps: {
          "value": rate.website_rate
        },
        on: {
          "input": function input($event) {
            if ($event.target.composing) return;
            _vm.$set(rate, "website_rate", $event.target.value);
          }
        }
      }), _c('span', [_vm._v("%")])]), _c('small', [_vm._v("Dedené: " + _vm._s(_vm.effectiveWebsiteRate(rate)) + " %")])]), _c('label', {
        staticClass: "rate-input",
        attrs: {
          "data-label": "Akciová v porovnaní"
        }
      }, [_c('span', {
        staticClass: "sr-only"
      }, [_vm._v("Akciová sadzba v porovnaní")]), _c('span', {
        staticClass: "number-input"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: rate.comparison_rate,
          expression: "rate.comparison_rate"
        }],
        attrs: {
          "type": "number",
          "min": "0",
          "max": "99.99",
          "step": "0.01",
          "inputmode": "decimal",
          "placeholder": "dediť"
        },
        domProps: {
          "value": rate.comparison_rate
        },
        on: {
          "input": function input($event) {
            if ($event.target.composing) return;
            _vm.$set(rate, "comparison_rate", $event.target.value);
          }
        }
      }), _c('span', [_vm._v("%")])]), _c('small', [_vm._v("Dedené: " + _vm._s(_vm.effectiveComparisonRate(rate)) + " %")])]), _c('label', {
        staticClass: "visibility-toggle",
        attrs: {
          "data-label": "Zobraziť na webe"
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: rate.visible_on_website,
          expression: "rate.visible_on_website"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(rate.visible_on_website) ? _vm._i(rate.visible_on_website, null) > -1 : rate.visible_on_website
        },
        on: {
          "change": function change($event) {
            var $$a = rate.visible_on_website,
              $$el = $event.target,
              $$c = $$el.checked ? true : false;
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && _vm.$set(rate, "visible_on_website", $$a.concat([$$v]));
              } else {
                $$i > -1 && _vm.$set(rate, "visible_on_website", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
              }
            } else {
              _vm.$set(rate, "visible_on_website", $$c);
            }
          }
        }
      }), _vm._m(9, true), _c('small', [_vm._v(_vm._s(rate.visible_on_website ? "Zobrazená" : "Skrytá"))])]), _c('div', {
        staticClass: "row-action",
        attrs: {
          "data-label": "Akcia"
        }
      }, [_c('button', {
        staticClass: "save-row-button",
        attrs: {
          "type": "button",
          "disabled": !_vm.isRateDirty(rate) || Boolean(_vm.rateValidationError(rate)) || _vm.isSaving(rate.id)
        },
        on: {
          "click": function click($event) {
            return _vm.saveRate(rate);
          }
        }
      }, [_vm._v(" " + _vm._s(_vm.isSaving(rate.id) ? "Ukladám" : "Uložiť") + " ")]), _vm.rateValidationError(rate) ? _c('small', {
        staticClass: "validation-message"
      }, [_vm._v(" " + _vm._s(_vm.rateValidationError(rate)) + " ")]) : _vm._e()])]);
    })], 2);
  }), !_vm.groupedRates.length ? _c('div', {
    staticClass: "page-state empty-state"
  }, [_c('strong', [_vm._v("Nenašli sa žiadne sadzby.")]), _c('span', [_vm._v("Skúste zmeniť vyhľadávanie alebo filtre.")]), _c('button', {
    staticClass: "secondary-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearFilters
    }
  }, [_vm._v(" Zrušiť filtre ")])]) : _vm._e()]], 2) : _vm.activeSection === 'financiers' ? _c('admin-financiers-settings') : _vm.activeSection === 'feedback' ? _c('admin-feedback-settings') : _vm._e()], 1)]) : _c('div', {
    staticClass: "page-state unauthorized-state"
  }, [_c('strong', [_vm._v("Táto sekcia je dostupná iba administrátorom.")])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('header', {
    staticClass: "settings-header"
  }, [_c('div', [_c('div', {
    staticClass: "eyebrow"
  }, [_vm._v("Bankari Broker")]), _c('h1', [_vm._v("Nastavenia")]), _c('p', [_vm._v(" Centrálne miesto pre údaje, ktoré používajú kalkulačky aj web bankari.sk. ")])]), _c('div', {
    staticClass: "admin-badge"
  }, [_c('span', {
    staticClass: "admin-badge-dot"
  }), _vm._v(" Len pre administrátorov ")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', [_c('strong', [_vm._v("Úrokové sadzby")]), _c('small', [_vm._v("Kalkulačka a web")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', [_c('strong', [_vm._v("Finančníci")]), _c('small', [_vm._v("Účty, dáta a lokality")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "settings-navigation-item disabled"
  }, [_c('span', {
    staticClass: "navigation-icon"
  }, [_vm._v("★")]), _c('span', [_c('strong', [_vm._v("Kampane bánk")]), _c('small', [_vm._v("Pripravujeme")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', [_c('strong', [_vm._v("Feedback")]), _c('small', [_vm._v("Hlásenia používateľov")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "section-kicker"
  }, [_vm._v("Hypotéky")]), _c('h2', [_vm._v("Úrokové sadzby")]), _c('p', [_vm._v(" Zmeny sa zapisujú do API. Web bankari.sk si ich načíta automaticky, spravidla do 5 minút. ")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "rate-guide"
  }, [_c('div', [_c('strong', [_vm._v("Základná sadzba")]), _c('span', [_vm._v("Používa ju hypotekárna kalkulačka v Brokeri.")])]), _c('div', [_c('strong', [_vm._v("Sadzba pre web")]), _c('span', [_vm._v("Prázdna hodnota automaticky použije základnú sadzbu.")])]), _c('div', [_c('strong', [_vm._v("Akciová v porovnaní")]), _c('span', [_vm._v("Prázdna hodnota použije sadzbu pre web.")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "history-note"
  }, [_c('span', {
    staticClass: "history-note-icon"
  }, [_vm._v("↗")]), _c('span', [_vm._v(" Každé uloženie skutočnej zmeny vytvorí historický bod s časom a administrátorom. Dáta tak budú pripravené pre budúce grafy vývoja sadzieb. ")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "rate-table-header",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('span', [_vm._v("Účel")]), _c('span', [_vm._v("Fixácia")]), _c('span', [_vm._v("Základná")]), _c('span', [_vm._v("Pre web")]), _c('span', [_vm._v("V porovnaní")]), _c('span', [_vm._v("Web")]), _c('span')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    staticClass: "toggle-track"
  }, [_c('span')]);

}]

export { render, staticRenderFns }